export const reducer = (actionsMapping, state, action) =>
  actionsMapping.hasOwnProperty(action.type)
    ? actionsMapping[action.type](state, action.payload)
    : state;
